import '../index.css';
var styles = {
  "datePicker": "bp_date_picker_module_datePicker--454fa",
  "disabled": "bp_date_picker_module_disabled--454fa",
  "label": "bp_date_picker_module_label--454fa",
  "group": "bp_date_picker_module_group--454fa",
  "groupContainer": "bp_date_picker_module_groupContainer--454fa",
  "error": "bp_date_picker_module_error--454fa",
  "groupContainerInput": "bp_date_picker_module_groupContainerInput--454fa",
  "groupContainerInputSegment": "bp_date_picker_module_groupContainerInputSegment--454fa",
  "button": "bp_date_picker_module_button--454fa",
  "clear": "bp_date_picker_module_clear--454fa",
  "inlineError": "bp_date_picker_module_inlineError--454fa",
  "datePickerPopoverContent": "bp_date_picker_module_datePickerPopoverContent--454fa",
  "slide": "bp_date_picker_module_slide--454fa"
};
export { styles as default };